<template>
<div class="container">
    <o2o-errand-head :flag="true"></o2o-errand-head>
<!--     <div class="content">
        <div class="background"><img src="../../../assets/image/member/member-o2o-errand-bg.png"></div>
        <div class="input-wrapper" @click="goOrder(0)"><p>输入想买的商品，如一杯星巴克大杯拿铁</p><div class="btn">去下单</div></div>
        <div class="class-wrapper mt-20" v-if="errand_class_list.length">
            <h2>快速导购</h2>
            <div class="class-item">
                <div class="item" v-for="(item,index) in errand_class_list" :key="item.o2o_errand_class_id" @click="goOrder(item.o2o_errand_class_id)">
                    <img :src="item.o2o_errand_class_logo_url">
                    <div class="name">{{item.o2o_errand_class_name}}</div>
                </div>
            </div>
        </div>
        <div class="class-wrapper" v-if="errand_class_recommend_list.length">
            <h2>精选大牌</h2>
            <div class="class-item">
                <div class="item" v-for="(item,index) in errand_class_recommend_list" :key="item.o2o_errand_class_id" @click="goOrder(item.o2o_errand_class_id)">
                    <img :src="item.o2o_errand_class_logo_url">
                    <div class="name">{{item.o2o_errand_class_name}}</div>
                </div>
            </div>
        </div>
    </div> -->

  <div>
    <index-header></index-header>
    <index-menu  v-if="navs && navs.length > 0" :items="navs"></index-menu>
    <common-store-list />
  </div>
</div>
</template>

<script>
import { Indicator, MessageBox, Toast } from 'mint-ui'
import O2oErrandHead from './O2oErrandHead'
// import { getErrandClassList } from '../../../api/memberO2oErrand'
import { mapMutations } from 'vuex'
import { homeIndexNavList } from '../../../api/homeindex'
import IndexHeader from '../../home/waimai/IndexHeader'
import CommonStoreList from '../../home/common/CommonStoreList'
import IndexMenu from '../../home/waimai/IndexMenu'
export default {
  name: 'MemberO2oErrand',
  components: {
    O2oErrandHead,
    IndexHeader,
    CommonStoreList,
    IndexMenu
  },
  computed: {
    navs: {
      get() {
        return this.$store.state.store.navs
      },
      set(value) {
        this.setNavs(value)
      }
    }
  },
  created () {
    homeIndexNavList().then(
      (response) => {
        if (response.result && response.result.navs) {
          this.navs = response.result.navs
        }
      })
  },
  methods: {
    ...mapMutations({
      setNavs: 'setNavs'
    })
  }
}
</script>

<style scoped lang="scss">
    .content{width:100%;background:#fff;
        .background{
            img{width:100%;border-radius: .2rem;}
        }
        .input-wrapper{position: relative;font-size:.65rem;color:#999;padding:1rem .3rem 3.5rem;box-sizing:border-box;
            top: .2rem;
            width: 92%;
            margin: 0 auto;
            box-shadow: 0 .2rem 0.4rem 0 rgba(200,200,200,.4);
            border-radius: 0.2rem;
            background-color: #fff;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            display: flex;

            .btn{position: absolute;left: 50%;margin-left: -3.5rem;bottom: -1rem;color:#fff;background:#FFAD10;width:7rem;text-align:center;font-size:.8rem;border-radius:1.6rem;height: 2rem;line-height:2rem;display:inline-block;vertical-align: middle}
        }
        .class-wrapper{padding:.6rem; box-shadow: 0 .2rem 0.4rem 0 rgba(200,200,200,.4);margin-top: .5rem;
            h2{font-size:.8rem;font-weight: bold;}
            .class-item{overflow:hidden;
                .item{width:33.33%;float:left;text-align:center;font-size:.7rem;padding-top:1rem;
                    img{height:4.5rem;margin-bottom:.5rem;}
                }
            }
        }
    }

</style>
